import { Fragment } from "react";
import henceofrthEnums from "../../utils/henceofrthEnums";

export default ({ order_status, onClick, tracking, delivery_type, onSendOtp, onVerifyOtp }: any) => {
    if (order_status === henceofrthEnums.OrderStatus.DELIVERED) {
        return <Fragment></Fragment>;
    }

    // If delivery type is PICKUP and order is PLACED, show Send OTP and Verify OTP buttons
    if (delivery_type === 'PICKUP' && order_status === henceofrthEnums.OrderStatus.PLACED) {
        return (
            <Fragment>
                {/* <button 
                    type="button" 
                    className={`btn btn-theme text-white fw-bold bg-warning border-warning me-2`} 
                    onClick={() => onSendOtp()}
                >
                    Send OTP
                </button> */}
                {/* <button 
                    type="button" 
                    className={`btn btn-theme text-white fw-bold bg-success border-success`} 
                    onClick={() => onVerifyOtp()}
                >
                    Verify OTP
                </button> */}
                <button
                    type="button"
                    className={`btn btn-theme text-white fw-bold bg-success border-success`}
                    onClick={() => onClick(henceofrthEnums.OrderStatus.DELIVERED)}
                >
                    {/* Proceed To Delivery */}
                    Mark As Delivered
                </button>
            </Fragment>
        );
    }

    // For other cases, show Proceed to Ship/Deliver button
    return (
        <button
            type="button"
            className={`btn btn-theme text-white fw-bold ${order_status === henceofrthEnums.OrderStatus.PLACED ? 'bg-warning border-warning' : order_status === henceofrthEnums.OrderStatus.SHIPPED ? 'bg-success border-success' : ''}`}
            onClick={() => onClick(order_status == henceofrthEnums.OrderStatus.PLACED ? henceofrthEnums.OrderStatus.SHIPPED : henceofrthEnums.OrderStatus.DELIVERED)}
            disabled={order_status === henceofrthEnums.OrderStatus.DELIVERED}
        >
            {order_status === henceofrthEnums.OrderStatus.PLACED ? 'Proceed to shipped' : 'Proceed to Delivered'}
        </button>
    );
}
